import React, { useEffect, useState } from "react";
import { Button, IconCheckCircle, IconXCircle, Table, Tooltip, Tabs, IconDownload } from "@veneer/core";
import { Row, Col, Container } from 'react-bootstrap';
import Swal from "sweetalert2";
import ConnectAPI from '../../services/api';
import { useTranslation } from "react-i18next";
import $, { map } from 'jquery';
import TableDataUpload from "./TableDataUpload";

const DataUpload = (props) => {
    const [t, i18n] = useTranslation();
    const connectApi = new ConnectAPI();
    const [activeTabIndex, setactiveTabIndex] = useState(1);
    const [headers, setheaders]=useState([]);
    const [showSCDetail, setShowSCDetail] = useState(false);
    const [idelement, setidelement]=useState();
    const [NameElement, setNameElement]=useState("");
    const [fulldata,setfulldata]=useState([]);
    const [allokbtn,setallokbtn]=useState("");
    const selectTab = (event) => (index) => {
        setactiveTabIndex(index);
    };
    const hideSCDetailsModal = () => {
        setShowSCDetail(false);
    }
    const successupload=()=>{
        setShowSCDetail(false);
        start();
    }

    useEffect(()=>{
        //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
        start();
    },[]);

    const start=()=>{
        connectApi
        .get("api/Channels/GetHeaderTabs","",consolid)
        .catch((error) => {
            console.log(error);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        });
    }
    function showmodal(element){
        let liItem = element.currentTarget.id;
        setNameElement(element.currentTarget.name);
        setidelement(liItem);
        setShowSCDetail(true);
    }
    const consolid = (status, data) => {
        let Tables_content=[];
        let FullData=data.uploadDates;
        let allok=data.tabs.find(element => element.idItem==99);
        if (allok.uploadDate===null){

        }else{
            setallokbtn("disabled");
        }
        data.tabs.forEach(element=>{
            let content=[];
            let content2=[];
            data.uploadDates.forEach(item => {
                if(element.idItem==item.idParent){
                    if (item.type=="upload"){
                        if(item.uploadDate===null){
                            if (item.dependent.length==0){
                                content.push({
                                    reportType: item.name,
                                    reportStatus: <IconXCircle disabled />,
                                    reportSubmit: <Button appearance="tertiary" id={item.idItem} name={item.name} onClick={showmodal.bind(this)}>{t('Submit')}</Button>
                                });
                            }else{
                                var depend=item.dependent.split(",");  
                                var count=depend.length;
                                var found=0;
                                FullData.forEach(dat=>{
                                if (dat.uploadDate===null){}else{
                                    if (depend.includes(dat.idItem.toString())){
                                        found=found+1;
                                    }
                                }   
                                });
                                if (count==found){
                                    content.push({
                                        reportType: item.name,
                                        reportStatus: <IconXCircle disabled />,
                                        reportSubmit: <Button appearance="tertiary" id={item.idItem} onClick={showmodal.bind(this)}>{t('Submit')}</Button>
                                    });
                                }else{
                                    content.push({
                                        reportType: item.name,
                                        reportStatus: <IconXCircle disabled />,
                                        reportSubmit: <Button appearance="tertiary" disabled id={item.idItem} onClick={showmodal.bind(this)}>{t('Submit')}</Button>
                                    });
                                }
                            }
                        }else{
                            if (allok.uploadDate===null){
                                content.push({
                                    reportType: item.name,
                                    reportStatus: <Tooltip arrow content={"Submitted on "+item.uploadDate}><IconCheckCircle color="colorHpBlue6" filled /></Tooltip>,
                                    reportSubmit: <Button appearance="tertiary" id={item.idItem} onClick={showmodal.bind(this)}>{t('Submit')}</Button>
                                });
                            }else{
                                content.push({
                                    reportType: item.name,
                                    reportStatus: <Tooltip arrow content={"Submitted on "+item.uploadDate}><IconCheckCircle color="colorHpBlue6" filled /></Tooltip>,
                                    reportSubmit: <Button appearance="tertiary" disabled id={item.idItem} onClick={showmodal.bind(this)}>{t('Submit')}</Button>
                                });
                            }
                           
                        }
                    }else{
                        var depend=item.dependent.split(",");  
                        var count=depend.length;
                        var found=0;
                        FullData.forEach(dat=>{
                            if (dat.uploadDate===null){}else{
                                if (depend.includes(dat.idItem.toString())){
                                    found=found+1;
                                }
                            }
                           
                        });
                        if (found==count){
                            if (allok.uploadDate===null){
                                content2.push({
                                    type: item.name,
                                    downloadbtn:<Button  trailingIcon={<IconDownload />} onClick={showmodal.bind(this)} appearance="tertiary" id={item.idItem} >{t('download')}</Button>
                                });
                            }else{
                                content2.push({
                                    type: item.name,
                                    downloadbtn:<Button disabled trailingIcon={<IconDownload />} onClick={showmodal.bind(this)} appearance="tertiary" id={item.idItem} >{t('download')}</Button>
                                });
                            }
                            
                        }else{
                            content2.push({
                                type: item.name,
                                downloadbtn:<Button trailingIcon={<IconDownload />} disabled appearance="tertiary" id={item.idItem} >{t('download')}</Button>
                            });
                        }
                    }
                }
            });
            let tabl=
                <>
                    <Table
                        columns={[
                            {
                                id: "reportType",
                                label: "Report Type"
                            },
                            {
                                id: "reportStatus",
                                label: "Status"
                            },
                            {
                                id: "reportSubmit",
                                label: ""
                            }
                        ]}
                        data={content}
                        preferences={{
                            width: [
                            {
                                columnId: 'reportType', width:500
                            },
                            {
                                columnId: 'reportStatus', width: 300
                            },
                            {
                                columnId: 'reportSubmit', width: 200
                            },
                            ]
                        }}
                    />
                    <br/>
                    <br/>
                    <br/>
                    <Table
                        columns={[
                            {
                                id:"type",
                                label:"Description"
                            },
                            {
                                id:"downloadbtn",
                                label:""
                            }
                        ]}
                        data={content2}
                        preferences={{
                            width: [
                                {
                                    columnId: 'type', width:800
                                },
                                {
                                    columnId: 'downloadbtn', width: 300
                                }
                            ]
                        }}
                    />
                </>
                ;
            if (element.idItem!=99){
                Tables_content.push({ id: element.idItem, label: element.name, content: <div style={{ padding: '30px' }}> {tabl} </div> });
            }
            
        });
        setheaders(Tables_content);
    }
    const result_allok=(status,data)=>{
        start();
    }
    const set_all_ok=()=>{
        connectApi
        .get("api/Channels/all_ok","",result_allok)
        .catch((error) => {
            console.log();
            if (error?.response?.status==555)
            {
                Swal.fire(
                    "Error "+t("All_ok_error") ,
                    error?.response?.data,
                    "error"
                );
            }else{
                 Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            }
           
        });
    }
    const check_ok=()=>{
        Swal.fire({
            title: 'Are you sure?',
            text: t("All_ok_question"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
          }).then((result) => {
            if (result.isConfirmed) {
                set_all_ok();
            }
          })
    }
    return (
        <div>
            <div className="row" style={{ textAlign: "left", padding: "0.5%" }}>
                <Button appearance="secondary" 
                    onClick={check_ok}
                    disabled={allokbtn}
                >
                        Secondary
                </Button>
            </div>
           
                
           
            <Tabs
                controlId="default"
                onChangeTab={selectTab()}
                selectedTabId={activeTabIndex}
                tabs={headers}
            />
            <TableDataUpload onShowModal={showSCDetail} onCloseSCDetailsModal={hideSCDetailsModal} idelement={idelement} NameElement={NameElement}  successupload={successupload} />
        </div>
    );
}

export default DataUpload